import React, { ReactNode } from 'react'

import { MarginProps } from 'styled-system'

import { Text } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

type Props = MarginProps & {
  centered?: boolean
  inverse?: boolean
  text: ReactNode
}

function PrimaryHeading({ centered, inverse, text, ...rest }: Props) {
  const { isMobile } = useResponsiveLayout()

  return (
    <Text
      {...rest}
      accent={!inverse}
      as="h2"
      bold
      center={centered}
      inverse={inverse}
      preWrap
      screen32={isMobile}
      screen40={!isMobile}
    >
      {text}
    </Text>
  )
}

export default PrimaryHeading
